import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Presentational Component
const Enum = ({ enums, type }) => {

	const option = enums[type];
	// console.log(option); // eslint-disable-line no-console

	return (
		<div className="enums">
			{Object.keys(option.fields)
				.sort()
				.map(key => <span className="enum-value" key={key} title={option.fields[key].summary}>{option.fields[key].name}</span>)
			}
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		enums: state.api.enums
	};
};

Enum.propTypes = {
	enums: PropTypes.object.isRequired,
	type: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(Enum);


// WEBPACK FOOTER //
// ./src/components/api/Enum.js